module.exports = __webpack_public_path__ + "img/banner_pos.2f207689.png";